(function() {
  "use strict";

  // SKU/EAN rows of ph-produktdaten (two copies per PDP, each loads this file).
  if (window.phVariantFields) return;
  window.phVariantFields = true;

  // Fired on the form; Impact's detail.formId is the "id" input, not the form id.
  function onVariantChange(event) {
    const form = event.target;
    const formId = form && typeof form.getAttribute === "function" ? String(form.getAttribute("id") || "") : "";
    if (!formId) return;
    const variant = (event.detail && event.detail.variant) || {};

    document.querySelectorAll("[data-ph-variant-row]").forEach((row) => {
      const productId = row.dataset.productId;
      if (!productId || !formId.startsWith(`product-form-${productId}-`)) return;
      const field = row.dataset.phVariantField;
      if (field !== "sku" && field !== "barcode") return;

      const value = String(variant[field] ?? "").trim();
      const cell = row.querySelector(".ph-produktdaten__value");
      if (cell) cell.textContent = value;
      row.hidden = value === "";
    });
  }

  document.addEventListener("variant:change", onVariantChange);
})();
